import ImageHelper from "../../util/ImageHelper";
import { localizedStrings } from "../../util/LocalizedStrings";

const backendUrl = 'https://photosherlock.com/api/';
const StatusCodeError = {
    tooManyRequests: 429,
    badRequest: 400,
    forbidden: 403
}
const headers = {
    'Version': '2',
    'Platform': 'web'
}

export default class BackendService {
    async uploadImage(file, resize) {
        if (resize) file = await ImageHelper.resize(file, 512)
        const data = new FormData()
        data.append('file', file)
        const response = await fetch(backendUrl + Endpoint.uploadImage, {
            method: 'POST',
            body: data,
            headers: headers
        })
        await this.handleError(response)
        const json = await response.json()
        return json['url']
    }

    async handleError(response) {
        if (!response.ok) {
            var errorMessage = localizedStrings.errorSomethingWentWrong
            switch (response.status) {
                case StatusCodeError.tooManyRequests:
                    errorMessage = localizedStrings.errorTooManyRequests
                    break
                case StatusCodeError.badRequest:
                    const json = await response.json()
                    if (json['content_filter_error'] === 'nd')
                        errorMessage = localizedStrings.errorContentFilter
                    break
                case StatusCodeError.forbidden:
                    throw new BackendLockedError()
            }
            throw new Error(errorMessage)
        }
    }

    async searchImage(imageUrl) {
        const searchParams = new URLSearchParams()
        searchParams.set(Parameter.imageUrl, imageUrl)
        const url = `${backendUrl}${Endpoint.searchImage}?${searchParams}`
        const response = await fetch(url, { headers: headers })
        await this.handleError(response)
        const json = await response.json()
        return this.parseSearchResults(json)
    }

    async getSearchResults(id) {
        const url = `${backendUrl}${Endpoint.searchResults}/${id}`
        const response = await fetch(url, { headers: headers })
        await this.handleError(response)
        const json = await response.json()
        return this.parseSearchResults(json)
    }

    parseSearchResults(json) {
        let tabs = json.tabs ?? []
        let sameResults = (tabs.find(item => item.type === 'same_results') ?? {}).images ?? []
        let similarResults = (tabs.find(item => item.type === 'similar_results') ?? {}).images ?? []
        return [sameResults, similarResults]
    }
}

class Endpoint {
    static uploadImage = 'upload-image'
    static searchImage = 'search-image';
    static searchResults = 'search-results';
}

class Parameter {
    static imageUrl = "image_url";
}

export class BackendLockedError extends Error {
    constructor() {
        const name = 'BackendLockedError'
        super(name)
        this.name = name
    }
}